module.exports = __webpack_public_path__ + "img/PROC.5f891c47.svg";